import React, { useCallback, useEffect, useState } from 'react'
import { ListGroup, Image, Button } from 'react-bootstrap'
import { useCart } from 'react-use-cart'
import { Link } from 'react-router-dom'
import { Icon } from '../../components'
import CloseButton from 'react-bootstrap/CloseButton'


import './order-panel.scss'

export const OrderPanel = ({ hidePanel, position}: any) => {
    const [positionTop, setPositionTop] = useState(110)

    useEffect(() => {
        window.addEventListener('click', hidePanel)

        return () => {
            window.removeEventListener('click', hidePanel)
        }
    },[hidePanel])

    const { 
        isEmpty,
        totalUniqueItems,
        totalItems,
        items,
        updateItemQuantity,
        removeItem,
        cartTotal,
        emptyCart,
    } = useCart()

    const handleScroll = useCallback(() => {
        setPositionTop(window.scrollY >= 111 ? 0: 110)
    },[])

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    },[handleScroll])


    return (
        <div className='div-panel' style={{top: `${positionTop}px`, right: `${position}px`}} onClick={e => e.stopPropagation()}>
            <CloseButton className='close-btn' onClick={hidePanel} />

            <h4>Koшничка</h4>
            <ListGroup  className='panel'>
                {isEmpty ? <p style={{textAlign: 'center', color: 'black', fontFamily: 'serif'}}>Кошничката е празна</p> :  items.map((product: any, index: any) => (
                    <ListGroup.Item className='item' key={index}>
                        <Image src={product.img} alt={product.title} width='80px' height='65px'/>
                        <div style={{textAlign: 'center'}}>
                            <p className='title'>{product.title}</p>
                            <p>{product.quantity} x {(product.price / 1.95583).toFixed(2)}€/{product.price.toFixed(2)}лв</p>

                        </div>
                        
                        <Icon
                            iconName="Trash3"
                            color="#C9A96E"
                            size={15}
                            className="delete"
                            onClick={() => removeItem(product.id)}
                            id={product.id}
                            title='изтрий'
                        />
                    </ListGroup.Item>
                ))}
            </ListGroup>
            {
                !isEmpty && 
                    <div className='checking-cart'>
                        <h5>Общо: <span style={{}}>{(cartTotal / 1.95583).toFixed(2)}€/{cartTotal.toFixed(2)}лв</span></h5>

                        <Link to='/cart?activePage=null' id='hide' onClick={hidePanel}>
                            <div className='checking-cart-btn'>
                                <Button>
                                    <Icon
                                        iconName='Handbag'
                                        size={20}
                                    />
                                    Преглед на кошничката
                                </Button>
                            </div>
                        </Link>
                    </div>
            }
        </div>
    )
}